import { Box, Divider, Typography, useTheme } from '@mui/material';
import { useAppSelector } from '../../../app/hooks';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { selectCurrOnboardingTab } from '../onboardingSlice';
import OnboardListFilters from './OnboardListFilters';

interface Props {
  visibleTotal: number;
  total: number;
}

const OnboardListHeader: React.FC<Props> = ({ visibleTotal, total }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const currTab = useAppSelector(selectCurrOnboardingTab);

  return (
    <Box sx={{ width: '100%', p: '0.4rem' }}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        <Typography variant='h5'>{t(currTab, { ns: 'common' })}</Typography>
        <Typography variant='h6'>
          <span style={{ color: theme.colors.common.bloomfieldGreen }}>
            {visibleTotal}
          </span>
          {` / ${total} `}
          {`${t('Total', { ns: 'common' })} `}
        </Typography>
      </Box>
      <Divider sx={{ bgcolor: theme.colors.darkTheme.grey.muted }} />
      <OnboardListFilters />
      <Divider sx={{ bgcolor: theme.colors.darkTheme.grey.muted }} />
    </Box>
  );
};

export default OnboardListHeader;
